import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import EmailIntegration from '../../../components/ProfilePage/EmailIntegration';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { config: { clientId } },
		profile: { email, emailProvider },
	} = state;

	return {
		clientId,
		userEmail: email,
		emailProvider,
	};
};

export default connect(mapStateToProps)(EmailIntegration);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/EmailIntegration/index.tsx